<!--
 * @Author: your name
 * @Date: 2021-11-05 11:51:26
 * @LastEditTime: 2023-06-15 16:41:41
 * @LastEditors: lizhenhao
 * @Description: 办卡 用户信息
 * @FilePath: \newProject\h5\src\pages\userInformation\index.vue
-->

<template>
  <div class="app-container">
    <div class="logo">
      <img v-if="resource == 'rys'" class="image" src="../../assets/activityUrl/rysBg.png" alt="" />
      <img v-else class="image" src="../../assets/logo.png" alt="" />
    </div>
    <div class="userForm">
      <!-- 用户信息 -->
      <van-form @submit="onSubmit" label-width="20vw" label-align="right" validate-trigger="onSubmit">
        <van-field v-model="userForm.name" name="用户名" label="真实姓名" placeholder="请填写申请人姓名" @blur="onBlur"
          :rules="[{ required: true, message: '' }]" />
        <van-field v-model="userForm.phone" maxlength="11" type="tel" name="手机号" label=" 手 机 号" placeholder="请填写申请人手机号"
          capture="camera" :rules="[{ required: true, message: '' }]" />
        <van-field v-model="userForm.idCard" maxlength="18" name="身份证" label=" 身 份 证" placeholder="请填写申请人身份证号码"
          :rules="[{ required: true, message: '' }]">
        </van-field>
        <van-field v-model="userForm.smsCode" maxlength="6" name="验证码" label=" 验 证 码" placeholder="请填写验证码"
          :rules="[{ required: true, message: '' }]">
          <template #button>
            <van-button round v-if="isFalg" size="small" type="info" native-type="button" @click="getCode">
              获取验证码
            </van-button>
            <van-button round v-else disabled size="small" type="info">
              {{ time }}秒后获取
            </van-button>
          </template>
        </van-field>
        <div class="agreement">
          <van-checkbox v-model="agreement" class="ty" icon-size="18px">
            我同意
          </van-checkbox>
          <span class="tick"><span @click="khAuthorizationAgreement">《用户授权协议》</span>与<span
              @click="khRegistrationAgreement">《易伙伴注册服务协议》</span></span>
        </div>
        <div class="goBtn">
          <van-button round block type="info" native-type="submit" :disabled="btnShow">去 申 请</van-button>
        </div>
      </van-form>
    </div>

    <!-- 弹窗 -->
    <van-dialog v-model="show" :title="title" width="380">
      <div class="diaAgreement" v-html="html"></div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import {
  Submit,
  getCode,
  link,
  khAuthorizationAgreement,
  khRegistrationAgreement,
  getCity,
  getShieldedArea,
  getWsLocationIP,
  getWsLocationAdcodeInfo,
} from "@/api/index";
export default {
  name: "UserInformation",
  data() {
    return {
      userForm: {
        name: "", //  性名
        phone: "", //  手机号
        smsCode: "", //  验证码
        idCard: "", //  身份证号码
        referKey: "", //  邀请码
        creditId: "", //  资源ID
        channelId: "", //  资源渠道  0 == 卡盒   1 == 网申
        province: "", // 省
        city: "", //市
        provinceCode: "", //省code
        cityCode: "", //市code
        creditName: "", // 资源名称
      },
      isFalg: true, //  获取验证码按钮是否禁用
      time: null, //  倒计时
      zIndex: -1,
      agreement: false, //  协议
      goUrl: "", //  去申请的 链接地址
      btnShow: false, // 控制按钮的开饭
      code: "", //  资源 编 码
      referKey: "", //  合伙人邀请码
      id: 0, //  资源 id
      jumpType: "", // 跳转方式    0 == 直接跳转      1 == 二维码页面
      resource: "",
      show: false, // 弹窗的关闭隐藏
      title: "", //  对话框的标题
      html: "",
    };
  },
  created() {
    var that = this;

    window.initMap = function () {
      var geolocation = new qq.maps.Geolocation(
        "KXFBZ-MQWCQ-MHC5Y-4UAHR-AALTF-2JB22"
      );
      geolocation.getLocation(
        function success(position) {
          console.log({ position });
          if (!position.province || !position.city) {
            // this.getLocation2();
          }
          that.userForm.province = position.province;
          that.userForm.city = position.city;
          that.userForm.provinceCode = position.adcode.substring(0, 2) + "0000";
          that.userForm.cityCode = position.adcode.substring(0, 4) + "00";
        },
        function error(result) {
          that.getLocation1();
        },
        {
          timeout: 15000, // 默认值为10s;
          failTipFlag: true,
        }
      );
    };

    // TODO 获取到二维码中的信息
    this.userForm.referKey = this.$route.query.referKey; //  合伙人邀请码
    this.userForm.creditId = this.$route.query.creditId; //  资源ID
    this.userForm.channelId = this.$route.query.channelId; //  资源渠道     0 == 卡盒   1 == 网申
    this.userForm.creditName = this.$route.query.name; //  资源名称
    this.userForm.resource = this.$route.query.resource; //  来源
    this.jumpType = this.$route.query.t; //  跳转方式

    this.userForm.orderSource = this.$route.query.userSource; //  用户来源
    this.userForm.merchantId = this.$route.query.merchantId; //  资源编码
    this.userForm.name = this.$route.query.userName; //  资源名称
    this.userForm.phone = this.$route.query.phone; //  资源ID
    this.userForm.idCard = this.$route.query.idCard; //  资源ID
    // console.log(this.$route.query);

    // 获取屏蔽城市提示文案
    var failMsg = null;
    getShieldedArea(this.userForm.creditId).then((res) => {
      if (res.code == 200) {
        if (res.msg) {
          failMsg = res.msg;
          this.$dialog
            .alert({
              title: `重要提示 ！！！`,
              message: `<p style='color: #ef7d1a; fontSize: 600;margin: 10px 0 0;text-align:left;height:30px'>请确保以上均为申请办卡人真实信息，后续申请资料需填写一致</p> ${failMsg
                ? ` <p style='text-align:left;color: red; fontSize: 600;margin:5px 0;height:120px;overflow:auto;letter-spacing:1px'>定位或户籍为${failMsg}的用户暂时无法办理${this.userForm.creditName}。
					  </p><p style='text-align:left;color: red; fontSize: 600;margin:0'>给您带来不便我们深表歉意！</p>`
                : ""
                }`,
              // showCancelButton: true,
            })
            .then(() => {
              this.verifyLocation()
            })
            .catch(() => { });
        } else {
          this.$dialog
            .alert({
              title: `重要提示 ！！！`,
              message: `<p style='color: #ef7d1a; fontSize: 600;margin: 10px 0 0;text-align:left;height:30px'>请确保以上均为申请办卡人真实信息，后续申请资料需填写一致</p> ${failMsg
                ? ` <p style='text-align:left;color: red; fontSize: 600;margin:5px 0;height:120px;overflow:auto;letter-spacing:1px'>定位或户籍为${failMsg}的用户暂时无法办理${this.userForm.creditName}。
					  </p><p style='text-align:left;color: red; fontSize: 600;margin:0'>给您带来不便我们深表歉意！</p>`
                : ""
                }`,
              // showCancelButton: true,
            })
            .then(() => { this.verifyLocation() })
            .catch(() => { });
        }
      } else {
        this.$dialog
          .alert({
            title: `重要提示 ！！！`,
            message: `<p style='color: #ef7d1a; fontSize: 600;margin: 10px 0 0;text-align:left;height:30px'>请确保以上均为申请办卡人真实信息，后续申请资料需填写一致</p> ${failMsg
              ? ` <p style='text-align:left;color: red; fontSize: 600;margin:5px 0;height:120px;overflow:auto;letter-spacing:1px'>定位或户籍为${failMsg}的用户暂时无法办理${this.userForm.creditName}。
					  </p><p style='text-align:left;color: red; fontSize: 600;margin:0'>给您带来不便我们深表歉意！</p>`
              : ""
              }`,
            // showCancelButton: true,
          })
          .then(() => { this.verifyLocation() })
          .catch(() => { });
      }
    });
    // 定位 此方式必须是https
    this.loadMap();
    this.btnShow = false;
  },
  methods: {
    loadMap() {
      var url =
        "https://apis.map.qq.com/tools/geolocation/min?key=KXFBZ-MQWCQ-MHC5Y-4UAHR-AALTF-2JB22&referer=location&callback=initMap"; // 成功回调为initMap方法
      var jsapi = document.createElement("script");
      jsapi.charset = "utf-8";
      jsapi.src = url;
      document.head.appendChild(jsapi);
    },
    verifyLocation() {
      setTimeout(() => {
        if (this.userForm.province == "" || this.userForm.city == "") {
          Dialog.confirm({
            title: '提示',
            message: '当前获取用户位置信息失败，无法校验地址是否在指定范围内，继续申请可能会导致无法办理该产品。',
          }).then(() => {
            // 点击确认后的操作
          }).catch(() => {
            // 点击取消后的操作
          });
        }
      }, 2000);
    },
    getLocation1() {
      var that = this;
      getWsLocationIP()
        .then((res) => {
          console.log("腾讯定位成功", res.result.ad_info);
          // if (res.status === 0) {
          if (res.status != 0) this.getLocation2();
          const data = res.result.ad_info;
          const adcode = data.adcode + "";
          // data是具体的定位信息
          console.log(
            data,
            data.province,
            data.city,
            adcode.substring(0, 2) + "0000",
            adcode.substring(0, 4) + "00"
          );
          if (!data.province || !data.city) {
            this.getLocation2();
          }
          that.userForm.province = data.province;
          that.userForm.city = data.city;
          that.userForm.provinceCode = adcode.substring(0, 2) + "0000";
          that.userForm.cityCode = adcode.substring(0, 4) + "00";
        })
        .catch(() => {
          this.getLocation2();
          console.log("定位失败");
        });
    },
    getLocation2() {
      try {
        var that = this;
        var map = new AMap.Map("iCenter");
        console.log(map.getAdcode());
        map.plugin("AMap.Geolocation", function () {
          var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 15000,
          });

          geolocation.getCurrentPosition();
          AMap.event.addListener(geolocation, "complete", onComplete);
          AMap.event.addListener(geolocation, "error", onError);

          function onComplete(data) {
            console.log("高德定位成功信息：", data);
            // data是具体的定位信息
            that.userForm.province = data.addressComponent.province;
            that.userForm.city = data.addressComponent.city;
            that.userForm.provinceCode =
              data.addressComponent.adcode.substring(0, 2) + "0000";
            that.userForm.cityCode =
              data.addressComponent.adcode.substring(0, 4) + "00";
          }

          function onError(data) {
            console.log("定位失败", data);
            // 定位失败时尝试使用模糊定位获取当前城市
            if (map.getAdcode() == 110000) return; //110000是默认值
            getCity(map.getAdcode())
              .then((res) => {
                if (res.status === 200) {
                  if (res.data.status == "1") {
                    console.log(res.data.districts[0].adcode, "----");
                    that.userForm.city = res.data.districts[0].name;
                    that.userForm.provinceCode =
                      res.data.districts[0].adcode.substring(0, 2) + "0000";
                    that.userForm.cityCode = res.data.districts[0].adcode;
                  }
                }
              })
              .catch(() => {
                getWsLocationAdcodeInfo(map.getAdcode())
                  .then((res) => {
                    that.userForm.city = res.data.result[0].fullname;
                    that.userForm.provinceCode =
                      res.data.result[0].id.substring(0, 2) + "0000";
                    that.userForm.cityCode = res.data.result[0].adcode;
                  })
                  .catch(() => {
                    console.log("获取定位失败");
                  });
              });
          }
        });
      } catch {
        console.log("高德定位失败");
      }
    },
    // 姓名校验
    onBlur() {
      let _name = new RegExp(
        "^[\u4E00-\u9FA5]{1,10}[·]{0,1}[\u4E00-\u9FA5]{1,20}$"
      );
      if (!_name.test(this.userForm.name + "")) {
        this.$notify({
          type: "warning",
          message: "请输入合法姓名",
        });
        return;
      }
    },

    // 获取信用卡 办卡连接
    goLink() {
      let code = this.code;
      link({
        code: code,
      }).then((res) => {
        this.userForm.bankUrl = res.msg;
      });
    },

    // 去申请
    async onSubmit(val) {
      // console.log(val);
      this.btnShow = true;
      // 姓名校验规则
      let _name = new RegExp(
        "^[\u4E00-\u9FA5]{1,10}[·]{0,1}[\u4E00-\u9FA5]{1,20}$"
      );
      if (!_name.test(this.userForm.name + "")) {
        this.$notify({
          type: "warning",
          message: "请输入合法姓名",
        });
        this.btnShow = false;
        return;
      }

      // 身份证校验规则
      let _IDRe18 =
        /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      let _IDre15 =
        /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
      // 校验身份证：
      if (
        _IDRe18.test(this.userForm.idCard) ||
        _IDre15.test(this.userForm.idCard)
      ) {
        if (!this.agreement) {
          Toast("请阅读并勾选协议");
          this.$notify({
            type: "warning",
            message: "请阅读并勾选协议",
          });
          this.btnShow = false;
          return;
        }

        // 给出提示 填写表格信息保持一直
        this.$dialog
          .alert({
            title: `重要提示 ！！！`,
            message: `<p style='color: #ef7d1a; fontSize: 600;'>请确保以上均为申请办卡人真实信息，后续申请资料需填写一致</p>`,
            showCancelButton: true,
          })
          .then((res) => {
            console.log(res);

            //  发起请求 获取跳转连接  请求参数看接口文档
            console.log("this.userForm", this.userForm);
            Submit(this.userForm).then((res) => {
              if (res.code != 200 && res.code != 501) {
                this.$notify({
                  type: "danger",
                  message: res.msg,
                });
                this.btnShow = false;
                return;
              }
              if (res.code == 501) {
                this.$dialog.alert({
                  message: `<p style='color: #ef7d1a;text-align:left; fontSize: 600;margin:5px 0;height:0px'>温馨提示:</p> ${res.msg
                    ? `<p style='text-align:left;color: red; fontSize: 600;margin:5px 0;height:120px;overflow:auto;letter-spacing:1px'>定位或户籍为${res.msg}的用户暂时无法办理${this.userForm.creditName}。
					  </p><p style='text-align:left;color: red; fontSize: 600;margin:0'>给您带来不便我们深表歉意！</p>`
                    : ""
                    }`,
                  showCancelButton: true,
                  showConfirmButton: false,
                });
                this.btnShow = false;
                return;
              }

              console.log(res);
              //  res  判断this.jumpType是跳转方式  然后跳转到办卡连接页面/二维码页面
              if (this.jumpType == 0) {
                // 直接跳转
                window.location.href = res.msg;
              }
              if (this.jumpType == 1) {
                // 二维码跳转
                //    设置缓存
                window.localStorage.setItem("jumpLink", res.msg);
                // 把获取到的连接放到缓存中 到qr页面去读缓存 生成二维码
                this.$router.push("/qr");
              }

              this.$notify({
                type: "success",
                message: "信息核验成功",
              });
            });
          })
          .catch(() => {
            this.btnShow = false;
          });
      } else {
        this.$notify({
          type: "warning",
          message: "请正确的输入身份证号码",
        });
        this.btnShow = false;
      }
    },

    // 扫描身份证
    getCardId() { },

    // 获取验证码
    getCode() {
      this.time = 60;
      let timer = null;
      // 验证手机号
      let str = /^[1]([3-9])[0-9]{9}$/;
      if (!str.test(this.userForm.phone)) {
        this.$notify({
          type: "danger",
          message: "请输入正确的手机号",
        });
        return;
      }

      this.isFalg = false;
      timer = setInterval(() => {
        this.time--;
        if (this.time <= 1) {
          clearTimeout(timer);
          this.isFalg = true;
          return;
        }
      }, 1000);

      getCode(this.userForm.phone)
        .then((res) => {
          if (res.code != 200) {
            this.$notify({
              type: "danger",
              message: res.msg,
            });
            return;
          }
          this.$notify({
            type: "primary",
            message: "验证码已发送",
          });
        })
        .catch((err) => {
          console.log("err, err", err);
          this.time = 60;
          this.isFalg = true;
          clearTimeout(timer);
          // vconsole.log()
          this.$notify({
            type: "danger",
            message: err.msg,
          });
        });
    },
    // 授权协议
    khAuthorizationAgreement() {
      this.title = "用户授权协议";
      this.show = true;
      khAuthorizationAgreement().then((res) => {
        this.html = res.data.content;
      });
      // this.$router.push("/khAuthorizationAgreement");
    },
    // 注册服务协议
    khRegistrationAgreement() {
      this.title = "易伙伴注册服务协议";
      this.show = true;
      khRegistrationAgreement().then((res) => {
        this.html = res.data.content;
      });
      // this.$router.push("/khRegistrationAgreement");
    },
  },
};
</script>

<style scoped>
.logo {
  width: 60%;
  margin: 10vh auto;
}

.logo .image {
  width: 100%;
  height: 70px;
}

.app-container {
  height: 100vh;
  overflow: hidden;
}

.agreement {
  width: 100%;
  padding-left: 2vw;
  margin: 10px;
  font-size: 13px;
  display: flex;
}

.tick span {
  color: #fa4f5f;
}

.goBtn {
  margin: 0 auto;
  width: 90vw;
  margin-top: 50px;
}

/* .van-dialog__header p{
	color: red;
  } */

.diaAgreement {
  height: 500px;
  padding: 10px;
  overflow: auto;
  text-indent: 1.5em;
}
</style>
